angular.module('app').filter('money', function(numberFilter) {
    "ngInject";
    return function(input, digits) {
        if(digits == null) {
            digits = 2;
        }

        return numberFilter(input/100, digits);

    };
});
